import { Buffer as NodeBuffer } from '../../node_modules/buffer/index.js';
export default NodeBuffer;
export { NodeBuffer as Buffer };
